import React, { useEffect } from "react"
import { Box, Container, Heading, Text, Flex } from "theme-ui"
import VideoStream from "../components/VideoStream"
import { useAnimate } from "framer-motion"

const PageHero = ({ block, media }) => {
  console.log(block)
  console.log(media)

  const [videoText, animateVideoText] = useAnimate()
  const [videoBox, animateVideoBox] = useAnimate()

  useEffect(() => {
    const animation = async () => {
      await animateVideoText(
        videoText.current,
        { opacity: [0, 1] },
        { delay: 0.5, duration: 0.7, ease: "anticipate" }
      )
    }
    animation()
  }, [])

  useEffect(() => {
    const animation = async () => {
      await animateVideoBox(
        videoBox.current,
        { scale: [0.5, 1], y: [200, 0] },
        { delay: 0.1, duration: 1, ease: "anticipate" }
      )
    }
    animation()
  }, [])

  return (
    <Box>
      {/* MOBILE */}
      <Container
        sx={{
          mt: 5,
          display: ["block", "block", "none", "none"],
          padding: [3, 3, 3, 4],
        }}
      >
        <Text
          variant="kicker"
          sx={{ color: "primary", borderColor: "primary" }}
        >
          {block.kicker}
        </Text>
        <Heading
          sx={{
            mt: [4],
            fontSize: [5, "48px"],
            color: "primary",
            fontWeight: 500,
            width: ["100%", "100%", "50%"],
            lineHeight: 1.2,
          }}
        >
          {block.title}
        </Heading>
        <Box
          sx={{
            mt: [4],
            position: "relative",
            height: ["220px"],
          }}
        >
          <Box
            sx={{
              borderRadius: ["30px", "60px"],
              overflow: "hidden",
              display: "flex",
              height: "100%",
            }}
          >
            {media && media.mimeType === "video/mp4" && (
              <VideoStream
                muxPlaybackId={media.video.muxPlaybackId}
                customData={media.customData}
                minHeight={"100%"}
              />
            )}
          </Box>
        </Box>
      </Container>

      {/* DESKTOP */}
      <Container
        variant="fw"
        sx={{
          mt: [7, 7, 7, 9],
          position: "relative",
          display: ["none", "none", "block", "block"],
        }}
      >
        <Box
          ref={videoBox}
          sx={{ borderRadius: "80px", overflow: "hidden", height: ["640px"] }}
        >
          {media && media.mimeType === "video/mp4" && (
            <VideoStream
              muxPlaybackId={media.video.muxPlaybackId}
              customData={media.customData}
              minHeight={"100%"}
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 1,
              }}
            />
          )}
        </Box>
        <Flex
          columns={[2]}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 2,
            p: 7,
            flexDirection: "column",
          }}
          ref={videoText}
        >
          <Text variant="kicker" sx={{ color: "white", borderColor: "white" }}>
            {block.kicker}
          </Text>
          <Heading
            sx={{
              fontSize: "48px",
              color: "white",
              fontWeight: 500,
              width: ["100%", "100%", "100%", "60%"],
              lineHeight: 1.2,
            }}
          >
            {block.title}
          </Heading>
        </Flex>
      </Container>

      <Container sx={{ padding: [3, 4] }}>
        <Box
          sx={{
            fontSize: "21px",
            fontWeight: 400,
            width: ["100%", "100%", "70%"],
            color: "dark",
            a: {
              color: "primary",
              textDecoration: "none",
              ":hover": {
                textDecoration: "underline",
              },
            },
          }}
          dangerouslySetInnerHTML={{ __html: block.body }}
        />
      </Container>
    </Box>
  )
}

export default PageHero
